const CIRCLE_BREAK_POINT = {
    ZERO: 0,
    FIRST: 1,
    SECOND: 2,
    THIRD: 3,
    FOURTH: 4
};

export default CIRCLE_BREAK_POINT;
